<template>

  <div class="sidebar" data-color="green" data-image="../assets/img/sidebar-5.jpg">
    <!--
        Tip 1: You can change the color of the sidebar using: data-color="purple | blue | green | orange | red"
        Tip 2: you can also add an image using data-image tag
    -->
    <div class="sidebar-wrapper">


        <a href="#"><img src="../assets/raefton-logo.svg" class="img-fluid p-4"></a>


      <div class="user border-0">
          <div class="info ml-4"><span id="myname">{{myself}}</span></div>
      </div>



      <ul class="nav">
        <li class="nav-item" id="myprofile">
          <a class="nav-link" href="#/contact/edit">
            <i class="nc-icon nc-circle-09"></i>
            <p>MY PROFILE</p>
          </a>
        </li>
        <li class="nav-item" id="dashboard">
          <a class="nav-link" href="#/dashboard/view">
            <i class="nc-icon nc-chart-bar-32"></i>
            <p>Dashboard</p>
          </a>
        </li>
        <li class="nav-item" id="asset">
          <a class="nav-link" href="#/asset/view">
            <i class="nc-icon nc-bus-front-12"></i>
            <p>Assets</p>
          </a>
        </li>
        <li class="nav-item" id="inventory">
          <a class="nav-link" href="#/inventory/view">
            <i class="nc-icon nc-app"></i>
            <p>Inventory</p>
          </a>
        </li>
        <li class="nav-item" id="navLink1">
          <a class="nav-link" href="#/rfq/view">
            <i class="nc-icon nc-delivery-fast"></i>
            <p>RFQs</p>
          </a>
        </li>
        <li class="nav-item" id="navLink2">
          <a class="nav-link" v-on:click="addRFQ();">
            <i class="nc-icon nc-paper-2"></i>
            <p>CREATE RFQ</p>
          </a>
        </li>
        <li class="nav-item" id="shipment">
          <a class="nav-link" href="#/shipment/view">
            <i class="nc-icon nc-paper-2"></i>
            <p>SHIPMENTS <span id="num_shippments"></span></p>
          </a>
        </li>
        <li class="nav-item" id="contact">
          <a class="nav-link" href="#/contact/view">
            <i class="nc-icon nc-circle-09"></i>
            <p>CONTACTS</p>
          </a>
        </li>
        <li class="nav-item" id="map">
          <a class="nav-link" href="#/map">
            <i class="nc-icon nc-pin-3"></i>
            <p>Map</p>
          </a>
        </li>
        <li v-if="!isProduction" class="nav-item" id="rfq-testing">
          <a class="nav-link" href="#/testing/rfq">
            <i class="nc-icon nc-circle-09"></i>
            <p>RFQ Testing</p>
          </a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" @click="logout">
            <i class="nc-icon nc-button-power"></i>
            <p>SIGN OUT</p>
          </a>
        </li>

      </ul>
    </div>
    <div class="sidebar-background" style="background-image: url(/static/img/sidebar-5.jpg) "></div>
  </div>

</template>
<script>

import Vue from 'vue'
import router from '../router'
import config from '../config'
import { isProduction } from '../config'
import apiService from '../services/api.service'
import firebaseService from '../services/firebase.service'


export default {
  name: 'sidebar',
  data: function () {
    return {
      myself: "",
      isProduction: isProduction
    }
  },
  props: {
    activeNavItem: {
      type: String,
      required: true
    }
  },
  beforeCreate () {
    this.myself = localStorage.getItem('local_name');
  },
  mounted () {
    console.log("Sidebar mounted, selected nav id is: " + this.activeNavItem);
    if (this.activeNavItem != null)
    {
      $("#" + this.activeNavItem).addClass("active");
    }

    this.myself = localStorage.getItem('local_name');
    
    if (sessionStorage.num_shippments == null)
    {
      console.log("Sidebar: getting number of shipments...");
      var numShipments = 0;
      apiService.get('/kong/api/v1/rfq/')
      .then(function (response) {
        for (var i = 0; i < response.data.Result.length; i++) {
          var rel = response.data.Result[i];
          var isDuplicate = false;
          var isAwarded = false;
          if (rel.assignees != null)
          {
            for (var j = 0; j < rel.assignees.length; j++) {
              if (rel.assignees[j].quote != null)
              {
                if (rel.assignees[j].quote.status == 'Awarded') {
                  isAwarded = true;
                }
              }

              if (rel.assignees[j].assignerid == rel.assignees[j].assigneeid && rel.securitylevel != "Creator") {
                // when we assign to ourselves don't show the RFQ twice. Just show the Creator version
                isDuplicate = true;
              }
            }
          }
          if (!isDuplicate && isAwarded) {
            numShipments++;
          }
        }

        sessionStorage.num_shippments = " (" + numShipments + ")";
        document.getElementById("num_shippments").innerHTML = sessionStorage.num_shippments;
        console.log("num shipments: " + sessionStorage.num_shippments);
      });

    }
    else
    {
      document.getElementById("num_shippments").innerHTML = sessionStorage.num_shippments;
    }
      
      


      initSliderMenu();
  },
  methods: {

    addRFQ: function () {
      console.log("---- addRFQ()");
      router.push('/rfq/edit/');
    },

    logout(){
      localStorage.setItem('local_name', '');
      firebaseService.logout();
    }

  }

}


function initSliderMenu()
{
  console.log("initSliderMenu()");
  $('#minimizeSidebar').click(function(){
      var $btn = $(this);

      if(lbd.misc.sidebar_mini_active == true){
          $('body').removeClass('sidebar-mini');
          lbd.misc.sidebar_mini_active = false;
      }else{
          setTimeout(function(){
              $('body').addClass('sidebar-mini');
              lbd.misc.sidebar_mini_active = true;
          },300);
      }

      // we simulate the window Resize so the charts will get updated in realtime.
      var simulateWindowResize = setInterval(function(){
          window.dispatchEvent(new Event('resize'));
      },180);

      // we stop the simulation of Window Resize after the animations are completed
      setTimeout(function(){
          clearInterval(simulateWindowResize);
      },1000);
  });
}




</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?4e59ca9c